import { useEvent } from "event/hooks/useEvent";

import type { Event } from "event/types/event.model";
import type { Message } from "wall/types/message.model";

import { UseFormReturnType } from "@mantine/form";
import { ListNavigation } from "event/play/components/ListNavigation";
import "event/play/common/PronosticView.css";

import { useSavedEvent } from "event/hooks/useSavedEvent";

import { useEffect, useState } from "react";
import { PronosticV2 } from "pronosticsv2/types/pronosticv2.model";
import { replacePlaceholders } from "event/play/components/Header2";
import { TransperentNavigation } from "event/play/components/TransperentNavigation";

type PSGHeaderProps = {
  form?: UseFormReturnType<
    Partial<Message>,
    (values: Partial<Message>) => Partial<Message>
  >;
  setIsMessageSent?: React.Dispatch<React.SetStateAction<boolean>>;
  pronostic: PronosticV2;
};

export function PronosticHeader({
  form,
  setIsMessageSent,
  pronostic,
}: PSGHeaderProps) {
  const event: Event | undefined = useEvent();
  const [savedEvent] = useSavedEvent(event?.id!);
  const [isHomePage, setIsHomePage] = useState(false);
  const [header, setHeader] = useState("");

  useEffect(() => {
    const eventHomePage = document.getElementById("EventHomePage");
    if (eventHomePage) {
      setIsHomePage(true);
    }
  }, []);
  const isTransperent =
    event?.navigation?.navigationType ===
    ("transparent" as "transperent" | "default");

  useEffect(() => {
    const modifiedHeader = replacePlaceholders(
      pronostic?.header!.html!,
      event?.team_name!,
      event?.images.teamLogo!,
      event?.opponent.name!,
      event?.opponent.logo!,
      event?.colors?.headerBackground!,
      event?.colors?.headerEventText!,
    );
    setHeader(modifiedHeader);
  }, [event, pronostic]);

  if (!event) {
    return <></>;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div dangerouslySetInnerHTML={{ __html: header }} />
      {savedEvent && isHomePage && !isTransperent && (
        <ListNavigation
          event={event}
          form={form}
          open={true}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && isHomePage && isTransperent && (
        <TransperentNavigation
          event={event}
          form={form}
          open={true}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && !isHomePage && !isTransperent && (
        <ListNavigation
          event={event}
          form={form}
          open={false}
          setIsMessageSent={setIsMessageSent}
        />
      )}
      {savedEvent && !isHomePage && isTransperent && (
        <TransperentNavigation
          event={event}
          form={form}
          open={false}
          setIsMessageSent={setIsMessageSent}
        />
      )}
    </div>
  );
}
